import { Injectable, EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';

// import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

// import { UrlService } from '@core/services/url/url.service';

import { AvailableRuleItem, RuleEvent, RuleAction, RuleCondition } from '@app/models/rules';
import * as fromRulesModel from '@app/models/rules';

import * as fromSettingsRulesState from '@app/store/state/settings/rules/rules.state';
import * as fromSettingsRulesActions from '@app/store/state/settings/rules/rules.actions';

// import { Rule } from '@core/objects/rule';



@Injectable({
    providedIn: 'root'
})
export class SettingsRulesService {

    constructor(private store: Store<fromSettingsRulesState.SettingsRules>) {}
 
    loadAvailableEvents = () => this.store.dispatch( new fromSettingsRulesActions.LoadAvailableEvents());

    selectAvailableEvents = () => this.store.select(fromSettingsRulesState.settingsRulesAvailableEventsSelector);

    selectAvailableConditions = () => this.store.select(fromSettingsRulesState.settingsRulesAvailableEventsConditionsSelector);
    
    selectAvailableActions = () => this.store.select(fromSettingsRulesState.settingsRulesAvailableEventsActionsSelector);

    selectConditionsEditForms = () => this.store.select(fromSettingsRulesState.settingsRulesEditFormsConditionsSelector);

    selectActionsEditForms = () => this.store.select(fromSettingsRulesState.settingsRulesEditFormsActionsSelector);

    // load rules list
    loadRules = () => this.store.dispatch( new fromSettingsRulesActions.LoadRules());

    selectRules = () => this.store.select(fromSettingsRulesState.settingsRulesRulesSelector);

    // active / deactive
    activeRule = (ruleId: number) => this.store.dispatch(new fromSettingsRulesActions.SetActiveRule(ruleId, true));

    deactiveRule = (ruleId: number) => this.store.dispatch(new fromSettingsRulesActions.SetActiveRule(ruleId, false));

    // load and edit rule
    selectEditing = () => this.store.select(fromSettingsRulesState.settingsRulesEditCurrentSelector);

    // select current event
    selectEditingEvent = () => this.store.select(fromSettingsRulesState.settingsRulesEditEventSelector);

    loadRule = (ruleId: number) => this.store.dispatch(new fromSettingsRulesActions.LoadRule(ruleId));
}

@Injectable({
    providedIn: 'root'
})
export class SettingsRulesEditorService {

    constructor(private store: Store<fromSettingsRulesState.SettingsRules>) {}

    clear = () => this.store.dispatch( new fromSettingsRulesActions.ClearRule());
 
    // TODO: maybe change in front to send only the key
    changeEventKey = (ruleEvent: fromRulesModel.AvailableRuleEventElement) => this.store.dispatch( new fromSettingsRulesActions.UpdateRuleEvent(ruleEvent.key));

    setDescription = (description: string) => this.store.dispatch( new fromSettingsRulesActions.SetRuleDescription(description));

    setConditionsControl = (control: string) => this.store.dispatch( new fromSettingsRulesActions.SetRuleConditionsControl(control));

    setRuleConditionsFormTerm = (form:fromRulesModel.AvailableRuleItemForm, term: string) => this.store.dispatch( new fromSettingsRulesActions.SetRuleConditionsFormTerm(form, term));

    setRuleActionsFormTerm = (form:fromRulesModel.AvailableRuleItemForm, key:string, term: string) => this.store.dispatch( new fromSettingsRulesActions.SetRuleActionsFormTerm(form, key, term));

    addAction = () => this.store.dispatch( new fromSettingsRulesActions.AddRuleAction());

    changeAction = (action: fromRulesModel.RuleAction) => this.store.dispatch( new fromSettingsRulesActions.ChangeRuleAction(action));
    
    changeActionKey = (action: fromRulesModel.RuleAction) => this.store.dispatch( new fromSettingsRulesActions.ChangeRuleActionKey(action));

    removeAction = (formId: string) => this.store.dispatch( new fromSettingsRulesActions.RemoveRuleAction(formId));

    addCondition = () => this.store.dispatch( new fromSettingsRulesActions.AddRuleCondition());

    changeCondition = (condition: RuleCondition) => this.store.dispatch( new fromSettingsRulesActions.ChangeRuleCondition(condition));
    
    removeCondition = (formId: string) => this.store.dispatch( new fromSettingsRulesActions.RemoveRuleCondition(formId));

    save = () => this.store.dispatch( new fromSettingsRulesActions.SaveRule());

    // scroll for multiselect
    setScroll = (key: string, scroll: number) => this.store.dispatch( new fromSettingsRulesActions.SetEditSelectScroll(key, scroll));
    
    selectScroll = (id: string) => this.store.select(fromSettingsRulesState.settingsRulesEditingScrollSelector(id));
}
